import React from 'react';
import { useSelector } from 'react-redux';

import KPTextform from '../../../../components/KPTComponents/KPTextform';

import { useScreenSize } from '../../../../hooks/useScreenSize';
import { MONOGRAPHS_CONSTANTS } from '../../../../constants';
import { getQcvScoreOptions } from '../../../../utils/qcvScoreOptions';

const { TYPE_OPTIONS: { INTERNATIONAL, DOMESTIC } } = MONOGRAPHS_CONSTANTS;

// QCV 2026: hiển thị đủ 5 phân loại sách (trong nước + thế giới) trong cùng 1 form.
const ALL_BOOK_OPTIONS = [...DOMESTIC, ...INTERNATIONAL];

// authorEditable=true: chỉ mở 2 trường số tác giả chính / số tác giả (màn duyệt thưởng).
export const monographForm = (values, mobileMode, disabled, typeOptions = ALL_BOOK_OPTIONS, authorEditable = false) => ([
  { key: 'title', width: 12, height: 1, label: 'Tên sách', value: values?.title, disabled, required: true },
  { key: 'publisher', width: 12, label: 'Nhà xuất bản', value: values?.publisher, disabled, required: true },
  { key: 'numberMain', width: 12, label: 'Số lượng tác giả chính (Tác giả đầu, tác giả liên hệ)', value: values?.numberMain, disabled: authorEditable ? false : disabled, type: 'int', required: true },
  { key: 'publishYear', width: mobileMode ? 7 : 3, label: 'Năm xuất bản', value: values?.publishYear, disabled, required: true },
  { key: 'page', width: mobileMode ? 5 : 2, label: 'Trang',type:'int', value: values?.page, disabled, required: true },
  { key: 'issn', width: mobileMode ? 5 : 4, label: 'ISSN/ISBN', value: values?.issn, disabled, required: true },
  { key: 'numberAuthor', width: mobileMode ? 7 : 3, label: 'Số tác giả', value: values?.numberAuthor, disabled: authorEditable ? false : disabled, required: true },
  { key: 'author', width: 12, height: 1, label: 'Danh sách tác giả', value: values?.author, disabled, required: true },
  { key: 'role', width: mobileMode ? 12 : 6, label: 'Vai trò', value: values?.role, options: MONOGRAPHS_CONSTANTS.ROLE_OPTIONS, disabled, required: true },
  { key: 'type', width: mobileMode ? 12 : 6, label: 'Phân loại', value: values?.type, options: typeOptions, disabled, required: true },
  { key: 'previewFile', width: 12, value: values?.previewFile, type: 'file', disabled, required: true },
]);

export default function BangSachForm(props) {
  const isMobileMode = useScreenSize();

  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  // Mục 5 (bảng điểm QCV): "Phân loại" sách lấy động từ qcv_score_infos (code
  // 5.x). Bảng điểm 2026 gộp chuyên khảo/giáo trình/tham khảo (NXB thế giới)
  // vào chung 1 mức điểm (5.5) -> dropdown chỉ còn 5 lựa chọn thay vì 8.
  const muc5Options = getQcvScoreOptions(scoreInformationList, '5');
  const typeOptions = muc5Options.length ? muc5Options : ALL_BOOK_OPTIONS;

  const textForm = monographForm(props.values, isMobileMode, props.disabled, typeOptions, props.authorEditable);
  return <KPTextform {...props} textForm={textForm} />
}